import { render } from "./BannersCreate.vue?vue&type=template&id=1d746d44&scoped=true"
import script from "./BannersCreate.vue?vue&type=script&lang=js"
export * from "./BannersCreate.vue?vue&type=script&lang=js"

import "./BannersCreate.vue?vue&type=style&index=0&id=1d746d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d746d44"]])

export default __exports__